
import React from 'react';
import { 
  Brain, Cloud, Database, Building2, Users, Calculator,
  MessageSquare, GraduationCap, Code, Phone, Server,
  Lock, UserCheck, ChartBar, Wallet, Building, ShoppingBag 
} from "lucide-react";

export const solutions = [
  {
    id: 1,
    title: "Business Solution",
    description: "Comprehensive business solutions to streamline your operations",
    icon: Building2,
    technologies: ["SAP", "Oracle", "Microsoft Dynamics"],
    slug: "business-solution"
  },
  {
    id: 2,
    title: "ERP Solution",
    description: "Integrated ERP solutions for better business management",
    icon: Database,
    technologies: ["SAP S/4HANA", "Oracle ERP Cloud", "Microsoft Dynamics 365"],
    slug: "erp-solution"
  },
  {
    id: 3,
    title: "AI-based Solution",
    description: "Cutting-edge artificial intelligence solutions for business automation",
    icon: Brain,
    technologies: ["Machine Learning", "Deep Learning", "NLP"],
    slug: "ai-based-solution"
  },
  {
    id: 4,
    title: "SAAS Solution",
    description: "Cloud-based software solutions delivered as a service",
    icon: Cloud,
    technologies: ["Cloud Computing", "Microservices", "API Integration"],
    slug: "saas-solution"
  },
  {
    id: 5,
    title: "IT Infrastructure",
    description: "Comprehensive IT infrastructure setup and management",
    icon: Server,
    technologies: ["Network Setup", "Server Management", "Security"],
    slug: "it-infrastructure"
  },
  {
    id: 6,
    title: "Contact Center",
    description: "Advanced calling and SMS dialer system with 5 extensions",
    icon: Phone,
    technologies: ["Multi-channel", "Call Recording", "Analytics", "Auto-dialer"],
    slug: "contact-center"
  },
  {
    id: 7,
    title: "HRM Solution",
    description: "Complete human resource management system",
    icon: UserCheck,
    technologies: ["Payroll", "Attendance", "Performance", "Recruitment"],
    slug: "hrm-solution"
  },
  {
    id: 8,
    title: "CRM Solution",
    description: "Customer relationship management system",
    icon: Users,
    technologies: ["Lead Management", "Sales Pipeline", "Analytics"],
    slug: "crm-solution"
  },
  {
    id: 9,
    title: "Accounting & Finance",
    description: "Financial management and accounting solutions",
    icon: Calculator,
    technologies: ["QuickBooks", "Xero", "Sage", "Custom Solutions"],
    slug: "accounting-finance"
  },
  {
    id: 10,
    title: "E-commerce Solution",
    description: "Complete online store and marketplace solutions",
    icon: ShoppingBag,
    technologies: ["WooCommerce", "Shopify", "Custom Development"],
    slug: "ecommerce-solution"
  },
  {
    id: 11,
    title: "Business Intelligence",
    description: "Data analytics and reporting solutions",
    icon: ChartBar,
    technologies: ["Power BI", "Tableau", "Custom Analytics"],
    slug: "business-intelligence"
  },
  {
    id: 12,
    title: "Enterprise Solutions",
    description: "Large-scale enterprise management systems",
    icon: Building,
    technologies: ["Enterprise Resource Planning", "Supply Chain", "Analytics"],
    slug: "enterprise-solutions"
  }
];

export default solutions;
